import React from 'react';
import PropTypes from 'prop-types';

const AUReceiptComponent = ({
  receiptText,
  helpText,
  showGoTo,
  buttons,
}) => {
  const renderButtons = buttons.map((btn) => <a key={btn.gotoLink} href={btn.gotoLink} className="button">{btn.gotoText}</a>);
  return (
    <div className="receipt">
      <div className="receipt__icon" data-icon="" />
      <h1 className="receipt__header" dangerouslySetInnerHTML={{ __html: receiptText }} />
      {helpText}
      {
        showGoTo && (
          <div className="receipt__post-action">
            {renderButtons}
          </div>
        )
      }
    </div>
  );
};

AUReceiptComponent.defaultProps = {
  showGoTo: true,
  helpText: null,
  buttons: [],
};

AUReceiptComponent.propTypes = {
  receiptText: PropTypes.string.isRequired,
  helpText: PropTypes.element,
  showGoTo: PropTypes.bool,
  buttons: PropTypes.arrayOf(PropTypes.shape({})),
};
AUReceiptComponent.displayName = 'AUReceiptComponent';
export default AUReceiptComponent;
